import React, { useState, useEffect, useContext } from 'react';
import { BrowserProvider, Contract, ethers } from 'ethers';
import PayTabs from './pay/PayTabs.js';
import { AuthContext } from '../AuthContext.js';

// Enhanced Web3Pay Contract ABI (Complete from your contract)
const WEB3PAY_ABI = [
  {"inputs":[{"internalType":"address","name":"_usdc","type":"address"},{"internalType":"address","name":"_usdt","type":"address"},{"internalType":"address","name":"_dai","type":"address"},{"internalType":"address","name":"_fdusd","type":"address"},{"internalType":"address","name":"_eurt","type":"address"},{"internalType":"address","name":"_weth","type":"address"},{"internalType":"address","name":"_usd1","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},
  {"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},
  {"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},
  {"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"SafeERC20FailedOperation","type":"error"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"accountId","type":"uint256"},{"indexed":false,"internalType":"string","name":"ensName","type":"string"}],"name":"AccountCreated","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"uint256","name":"newBalance","type":"uint256"}],"name":"BalanceUpdated","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"FeeUpdated","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"qrId","type":"uint256"},{"indexed":true,"internalType":"address","name":"payer","type":"address"}],"name":"QRPaymentCompleted","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"qrId","type":"uint256"},{"indexed":true,"internalType":"address","name":"creator","type":"address"},{"indexed":false,"internalType":"string","name":"qrReference","type":"string"}],"name":"QRPaymentCreated","type":"event"},
  {"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"txId","type":"uint256"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"enum Web3Pay.TransactionType","name":"txType","type":"uint8"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TransactionProcessed","type":"event"},
  // Contract constants and view functions
  {"inputs":[],"name":"DAI","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"EURT","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"FDUSD","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"FEE_DENOMINATOR","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"MAX_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"PLATFORM_WALLET","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"USD1","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"USDC","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"USDT","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  {"inputs":[],"name":"WETH","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},
  // Account management
  {"inputs":[{"internalType":"string","name":"ensName","type":"string"}],"name":"createAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},
  {"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"accounts","outputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"string","name":"ensName","type":"string"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"isActive","type":"bool"},{"internalType":"bool","name":"isVerified","type":"bool"}],"stateMutability":"view","type":"function"},
  // Balance management
  {"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"address","name":"token","type":"address"}],"name":"getBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
  {"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"depositERC20","outputs":[],"stateMutability":"nonpayable","type":"function"},
  {"inputs":[],"name":"depositETH","outputs":[],"stateMutability":"payable","type":"function"},
  {"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdrawERC20","outputs":[],"stateMutability":"nonpayable","type":"function"},
  {"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdrawETH","outputs":[],"stateMutability":"nonpayable","type":"function"},
  // Transfer functions
  {"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"description","type":"string"}],"name":"transfer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},
  {"inputs":[],"name":"transferFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
  // QR Payment functions
  {"inputs":[{"internalType":"address","name":"payee","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"qrReference","type":"string"},{"internalType":"bool","name":"isInStore","type":"bool"}],"name":"createQRPayment","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},
  {"inputs":[{"internalType":"uint256","name":"qrId","type":"uint256"},{"internalType":"string","name":"qrReference","type":"string"}],"name":"completeQRPayment","outputs":[],"stateMutability":"payable","type":"function"},
  {"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"qrPayments","outputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"creator","type":"address"},{"internalType":"address","name":"payee","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"feePercent","type":"uint256"},{"internalType":"uint256","name":"timestamp","type":"uint256"},{"internalType":"bool","name":"isCompleted","type":"bool"},{"internalType":"bool","name":"isInStore","type":"bool"}],"stateMutability":"view","type":"function"},
  // Transaction history - CORRECTED VERSION
  {
    "inputs": [
      {"internalType":"address","name":"account","type":"address"},
      {"internalType":"uint256","name":"limit","type":"uint256"}
    ],
    "name":"getRecentTransactions",
    "outputs": [
      {
        "components": [
          {"internalType":"uint256","name":"id","type":"uint256"},
          {"internalType":"address","name":"account","type":"address"},
          {"internalType":"enum Web3Pay.TransactionType","name":"txType","type":"uint8"},
          {"internalType":"string","name":"description","type":"string"},
          {"internalType":"address","name":"token","type":"address"},
          {"internalType":"uint256","name":"amount","type":"uint256"},
          {"internalType":"uint256","name":"fee","type":"uint256"},
          {"internalType":"uint256","name":"timestamp","type":"uint256"},
          {"internalType":"address","name":"counterparty","type":"address"},
          {"internalType":"string","name":"txReference","type":"string"}
        ],
        "internalType":"struct Web3Pay.TransactionRecord[]",
        "name":"",
        "type":"tuple[]"
      }
    ],
    "stateMutability":"view",
    "type":"function"
  }
];

// Contract address on Sepolia
const WEB3PAY_CONTRACT_ADDRESS = "0x01C9b7FdcA2e2E68fCd1D41ff3FCaccf3Bb57447";

const SUPPORTED_TOKENS = {
  USD1: 'USD1 (Gold/Reserve Backed)',
  USDT: 'USDT (Reserves Backed)',
  USDC: 'USDC (Government-Reg Backed)',
  DAI: 'DAI (Collateral Backed)',
  FDUSD: 'FDUSD (Reserves Backed)',
  EURT: 'EURT (Euro Reserves Backed)',
  WETH: 'WETH (Wrapped Ethereum)'
};

const Web3Pay = () => {
  const { isAuthenticated, ensName, loginWithSIWE, isENSHolder, address } = useContext(AuthContext) || {};

  // Component state
  const [account, setAccount] = useState(null);
  const [web3payContract, setWeb3payContract] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Contract data state
  const [contractData, setContractData] = useState({
    transferFee: 50,
    feeDenominator: 10000,
    feePercent: 0.5,
    platformWallet: '0x74338Aea95f8e80D64944f3F2adAC4c2e7Da919a',
    tokenAddresses: {},
    accountInfo: null
  });

  // Balance state for all supported tokens
  const [balances, setBalances] = useState({
    USDC: '0.0', USDT: '0.0', DAI: '0.0',
    FDUSD: '0.0', EURT: '0.0', WETH: '0.0',
    USD1: '0.0', ETH: '0.0'
  });

  // Recent transactions from contract
  const [contractTransactions, setContractTransactions] = useState([]);

  // Initialize Web3Pay contract
  useEffect(() => {
    const initContract = async () => {
      if (window.ethereum && isAuthenticated && isENSHolder) {
        try {
          setLoading(true);
          const provider = new BrowserProvider(window.ethereum);
          const accounts = await provider.send("eth_requestAccounts", []);
          setAccount(accounts[0]);

          // Check if on Sepolia testnet (chain ID 11155111)
          const network = await provider.getNetwork();
          console.log('Current network:', network.chainId.toString());

          if (network.chainId === 11155111n) {
            const signer = await provider.getSigner();
            const contractInstance = new Contract(WEB3PAY_CONTRACT_ADDRESS, WEB3PAY_ABI, signer);
            setWeb3payContract(contractInstance);

            // Load contract data
            await loadContractData(contractInstance, accounts[0]);

            setError(null);
          } else {
            setError("Please switch to Sepolia testnet (Chain ID: 11155111) to use Web3Pay.");
          }
        } catch (err) {
          setError(`Failed to initialize contract: ${err.message}`);
          console.error('Contract initialization error:', err);
        } finally {
          setLoading(false);
        }
      }
    };

    initContract();
  }, [isAuthenticated, isENSHolder]);

  // Load contract configuration data
  const loadContractData = async (contract, userAddress) => {
    try {
      const safeContractCall = async (contractFunction, fallbackValue = null) => {
        try {
          return await contractFunction();
        } catch (error) {
          console.error('Contract call failed:', error);
          return fallbackValue;
        }
      };

      const [
        transferFee,
        feeDenominator,
        platformWallet,
        usdcAddr,
        usdtAddr,
        daiAddr,
        fdusdAddr,
        eurtAddr,
        wethAddr,
        usd1Addr
      ] = await Promise.all([
        safeContractCall(() => contract.transferFee(), 50),
        safeContractCall(() => contract.FEE_DENOMINATOR(), 10000),
        safeContractCall(() => contract.PLATFORM_WALLET(), '0x74338Aea95f8e80D64944f3F2adAC4c2e7Da919a'),
        safeContractCall(() => contract.USDC(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.USDT(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.DAI(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.FDUSD(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.EURT(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.WETH(), '0x0000000000000000000000000000000000000000'),
        safeContractCall(() => contract.USD1(), '0x0000000000000000000000000000000000000000')
      ]);

      const tokenAddresses = {
        USDC: usdcAddr,
        USDT: usdtAddr,
        DAI: daiAddr,
        FDUSD: fdusdAddr,
        EURT: eurtAddr,
        WETH: wethAddr,
        USD1: usd1Addr
      };

      const feePercent = (Number(transferFee) / Number(feeDenominator) * 100);

      setContractData({
        transferFee: Number(transferFee),
        feeDenominator: Number(feeDenominator),
        feePercent: feePercent,
        feePercentDisplay: feePercent.toFixed(2),
        platformWallet: platformWallet,
        tokenAddresses: tokenAddresses
      });

      // Load user balances
      await loadBalances(contract, userAddress, tokenAddresses);

      // Load account info if user has an account
      if (userAddress) {
        try {
          const accountInfo = await contract.accounts(userAddress);
          setContractData(prev => ({ ...prev, accountInfo }));
        } catch (err) {
          console.log('No account found in contract for user:', userAddress);
        }
      }
    } catch (error) {
      console.error('Failed to load contract data:', error);
    }
  };

  // Load user token balances from contract
  const loadBalances = async (contract, userAddress, tokenAddresses) => {
    try {
      const balancePromises = Object.entries(tokenAddresses).map(async ([symbol, address]) => {
        if (address && address !== '0x0000000000000000000000000000000000000000') {
          const balance = await contract.getBalance(userAddress, address);
          const decimals = symbol === 'USDC' || symbol === 'USDT' ? 6 : 18;
          return [symbol, ethers.formatUnits(balance, decimals)];
        }
        return [symbol, '0.0'];
      });

      // Also get ETH balance
      const provider = new BrowserProvider(window.ethereum);
      const ethBalance = await provider.getBalance(userAddress);

      const balanceResults = await Promise.all(balancePromises);
      const newBalances = Object.fromEntries(balanceResults);
      newBalances.ETH = ethers.formatEther(ethBalance);

      setBalances(newBalances);
    } catch (error) {
      console.error('Failed to load balances:', error);
    }
  };

  // Load recent transactions from contract
  const loadContractTransactions = async (limit = 10) => {
    if (!web3payContract || !account) return;

    try {
      const transactions = await web3payContract.getRecentTransactions(account, limit);

      const formattedTxs = transactions.map((tx, index) => {
        try {
          const txId = tx?.id ? Number(tx.id) : index;
          const amount = tx?.amount ? ethers.formatUnits(tx.amount, 18) : '0';
          const timestamp = tx?.timestamp ? Number(tx.timestamp) : Math.floor(Date.now() / 1000);

          return {
            id: txId,
            account: tx?.account || account,
            txType: tx?.txType ? Number(tx.txType) : 2,
            description: tx?.description || 'Transaction',
            token: tx?.token || '0x0000000000000000000000000000000000000000',
            amount: amount,
            fee: tx?.fee ? ethers.formatUnits(tx.fee, 18) : '0',
            timestamp: timestamp,
            counterparty: tx?.counterparty || '0x0000000000000000000000000000000000000000',
            txReference: tx?.txReference || '',
            date: new Date(timestamp * 1000).toLocaleDateString(),
            metadata: {
              paymentType: getTransactionTypeString(Number(tx?.txType || 2)),
              isContractTx: true
            }
          };
        } catch (txError) {
          console.error('Error processing transaction:', txError);
          return {
            id: index,
            account: account,
            txType: 2,
            description: 'Transaction',
            token: '0x0000000000000000000000000000000000000000',
            amount: '0',
            fee: '0',
            timestamp: Math.floor(Date.now() / 1000),
            counterparty: '0x0000000000000000000000000000000000000000',
            txReference: '',
            date: new Date().toLocaleDateString(),
            metadata: {
              paymentType: 'transfer',
              isContractTx: true
            }
          };
        }
      });

      setContractTransactions(formattedTxs);
    } catch (error) {
      console.error('Failed to load contract transactions:', error);
      setContractTransactions([]);
    }
  };

  // Helper function to convert transaction type enum to string
  const getTransactionTypeString = (txType) => {
    const types = {
      0: 'deposit',
      1: 'withdraw',
      2: 'transfer',
      3: 'qr_payment',
      4: 'fee_collection'
    };
    return types[txType] || 'unknown';
  };

  // Refresh all data
  const refreshBalances = async () => {
    if (web3payContract && account) {
      await loadBalances(web3payContract, account, contractData.tokenAddresses);
      await loadContractTransactions();
    }
  };

  // ENS Domain Protection - Added same conditional rendering as other components
  if (!isAuthenticated || !isENSHolder) {
    return (
      <div style={{ textAlign: 'center', color: 'gold', marginTop: '20px' }}>
        <p>Please mint your .xbsys.eth subdomain to access Web3Pay.</p>
        <button
          onClick={loginWithSIWE}
          style={{
            background: 'transparent',
            border: '2px solid gold',
            color: 'gold',
            padding: '15px 30px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          Connect Wallet
        </button>
      </div>
    );
  }

  return (
    <section className="web3pay-container">
      {/* Gold Card Container - Same as Web3Markets.js and Web3Broker.js */}
      <div style={{
        background: 'black',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 0 20px gold',
        maxWidth: '1200px',
        margin: '20px auto',
      }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: 'gold', fontSize: '32px', fontWeight: 'bold', marginBottom: '10px' }}>
            Web3Pay.eth - Smart Contract Payment System
          </h1>
          <p style={{ color: 'gold', fontSize: '16px', marginBottom: '20px' }}>
            Advanced Multi-Token Payment & QR System with {contractData.feePercentDisplay || '0.50'}% fees
          </p>
        </div>

        {/* ENS Connection Status - Same as other components */}
        <div style={{
          backgroundColor: '#333',
          padding: '1rem',
          borderRadius: '5px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              background: isAuthenticated ? '#00FF00' : '#FF0000',
            }}></div>
            <span style={{ fontWeight: 'bold', color: isAuthenticated ? '#00FF00' : '#FF0000' }}>
              {isAuthenticated ? 'CONNECTED' : 'DISCONNECTED'}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: 'gold', fontSize: '14px' }}>
              {ensName ? `${ensName}` : address ? `${address.substring(0, 6)}...${address.substring(address.length - 4)}` : 'Not connected'}
            </span>
          </div>
        </div>

        {/* Contract Status */}
        <div style={{
          background: 'rgba(255,215,0,0.1)',
          border: '1px solid gold',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <h4 style={{ color: 'gold', margin: '0 0 10px 0' }}>Smart Contract Mode</h4>
          <div style={{ fontSize: '12px', color: 'gold' }}>
            <p><strong>Contract:</strong> {WEB3PAY_CONTRACT_ADDRESS.slice(0, 10)}...{WEB3PAY_CONTRACT_ADDRESS.slice(-8)}</p>
            <p><strong>Transfer Fee:</strong> {contractData.feePercentDisplay || '0.50'}%</p>
            <p><strong>Network:</strong> Sepolia Testnet | <strong>Status:</strong> Operational</p>
          </div>
        </div>

        {/* Error Display */}
        {error && (
          <div style={{
            color: 'red',
            marginBottom: '20px',
            textAlign: 'center',
            background: 'rgba(255,0,0,0.1)',
            padding: '10px',
            borderRadius: '5px'
          }}>
            {error}
          </div>
        )}

        {/* Balance Overview */}
        {web3payContract && (
          <div style={{
            backgroundColor: '#333',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
          }}>
            <h4 style={{ color: 'gold', marginBottom: '15px', textAlign: 'center' }}>Token Balances (Smart Contract)</h4>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: '15px',
            }}>
              {Object.entries(balances).map(([symbol, balance]) => (
                <div
                  key={symbol}
                  style={{
                    background: 'rgba(255, 215, 0, 0.1)',
                    border: '1px solid gold',
                    borderRadius: '8px',
                    padding: '15px',
                    textAlign: 'center'
                  }}
                >
                  <h4 style={{ color: 'gold', margin: '0 0 5px 0', fontSize: '16px' }}>{symbol}</h4>
                  <p style={{ color: 'white', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>
                    {parseFloat(balance).toFixed(6)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Main PayTabs Integration */}
        <div style={{
          backgroundColor: '#333',
          padding: '15px',
          borderRadius: '5px',
        }}>
          <PayTabs
            connectWallet={loginWithSIWE}
            walletAddress={address}
            web3payContract={web3payContract}
            contractMode={true}
            contractData={contractData}
            balances={balances}
            refreshBalances={refreshBalances}
            contractTransactions={contractTransactions}
          />
        </div>

        {/* Contract Info Footer */}
        <div style={{
          backgroundColor: '#333',
          padding: '15px',
          borderRadius: '5px',
          textAlign: 'center',
          marginTop: '20px'
        }}>
          <h4 style={{ color: 'gold', marginBottom: '10px' }}>Contract Information</h4>
          <p style={{ color: 'gold', margin: '5px 0', fontSize: '12px' }}>
            Contract: {WEB3PAY_CONTRACT_ADDRESS}
          </p>
          <p style={{ color: 'gold', margin: '5px 0', fontSize: '12px' }}>
            Transfer Fee: {contractData.feePercentDisplay || '0.50'}% | Platform Wallet: {contractData.platformWallet?.slice(0, 10)}...
          </p>
          <p style={{ color: 'gold', margin: '5px 0', fontSize: '12px' }}>
            Supported Tokens: {Object.keys(SUPPORTED_TOKENS).join(', ')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Web3Pay;
